export default __webpack_public_path__ + "static/media/calendar-check.7e22c298.svg";